module.exports = __webpack_public_path__ + "static/media/lmd.890c09c3.png";